export default __webpack_public_path__ + "static/media/servicetype_cast.87c4cec4.png";